import {
  formatIsoDate,
  formatName,
  renderStatus,
} from "../../../utils/generalUtils";

import GeneratePdf from "../../../generatePdf/GeneratePdf";
import { Space } from "antd";
import ViewingFormButton from "../../Form/ViewingFormButton";
// import ConfirmDelete from "../../ConfirmDelete/ConfirmDelete";

export const trlConfig = {
  docType: "Local Travel Request",
  title: "Local Travel Request",
  description:
    "Submit a request to travel locally for official university purposes. Your request will be reviewed by your assigned approver. Once approved, you may download the official travel document.",
  apiConfig: {
    get: "/employee/trl",
    post: "/employee/addtrl",
  },
  dataMapper: (item, index) => ({
    ...item,
    name: `${item?.submission?.submitter?.last_name || ""}, ${
      item?.submission?.submitter?.first_name || ""
    }`.trim(),
    formattedName: formatName(
      item?.submission?.submitter?.first_name,
      item?.submission?.submitter?.middle_name,
      item?.submission?.submitter?.last_name,
      "lfmcut"
    ),
    approver_name: `${item?.submission?.approval?.approver?.last_name || ""} ${
      item?.submission?.approval?.approver?.first_name || ""
    }`.trim(),
    formattedApproverName: formatName(
      item?.submission?.approval?.approver?.first_name,
      item?.submission?.approval?.approver?.middle_name,
      item?.submission?.approval?.approver?.last_name,
      "lfmcut"
    ),
    submitter_position: item?.submission?.position?.position_name,
    submitter_position_unit: item?.submission?.position?.unit,
    approval_date: item?.submission?.approval?.approval_date,
    remarks: item?.submission?.remarks,
    date_submitted: item?.created_at ? formatIsoDate(item?.created_at) : null,
    key: index + 1,
    status: item?.submission?.status,
  }),
  columns: (onDeleted) => [
    { title: "No.", dataIndex: "key", rowScope: "row", width: 60 },
    { title: "Destination", dataIndex: "destination", key: "destination" },
    {
      title: "Position",
      dataIndex: "submitter_position",
      key: "submitter_position",
    },
    { title: "Start Date", dataIndex: "start_date", key: "start_date" },
    { title: "End Date", dataIndex: "end_date", key: "end_date" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: renderStatus(
        ["pending"],
        ["approved"],
        ["disapproved", "denied"]
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, item) => (
        <Space>
          <GeneratePdf
            docuType="trl"
            contents={item}
            disabled={item?.status !== "approved"}
            isEmployee={true}
            isIcon={true}
          />
          <ViewingFormButton
            contents={item}
            viewingDataConfig={trlConfig.viewingDataConfig}
            isIcon={true}
          />
          {/* <ConfirmDelete
            isIcon={true}
            rowId={item?.id}
            buttonText="Delete Submission"
            docType="trl"
            onDeleted={onDeleted}
          /> */}
        </Space>
      ),
    },
    {
      title: "Date Submitted",
      dataIndex: "date_submitted",
      key: "date_submitted",
    },
  ],
  formFields: [
    {
      name: "date",
      label: "Date",
      type: "daterange",
      // onSameMonth: true,
      rules: [{ required: true, message: "This is required", type: "array" }],
    },
    {
      name: "destination",
      label: "Destination",
      placeholder: "Enter destination",
      rules: [
        { required: true, message: "This is required", whitespace: true },
      ],
    },
    {
      name: "purpose",
      label: "Purpose of Travel",
      placeholder: "Enter purpose of travel",
      rules: [
        { required: true, message: "This is required", whitespace: true },
      ],
    },
    {
      name: "expenses",
      label: "Estimated Expenses",
      placeholder: "Enter estimated expenses",
    },
    {
      name: "funding_source",
      label: "Funding Source",
      placeholder: "Enter funding source",
    },
    {
      name: "local_travel_transportation",
      label: "Local Travel Transportation",
      placeholder: "Enter Local Travel Transportation",
    },
    {
      name: "entitlement",
      label: "Entitlement",
      placeholder: "Enter entitlement",
    },
  ],
  viewingDataConfig: [
    {
      key: 1,
      collapseName: "Required Details",
      collapseItems: [
        { key: 1, name: "submitter_position", label: "Position" },
        { key: 2, name: "start_date", label: "Start Date" },
        { key: 3, name: "end_date", label: "End Date" },
        { key: 4, name: "destination", label: "Destination" },
        { key: 5, name: "purpose", label: "Purpose of Travel" },
      ],
    },
    {
      key: 2,
      collapseName: "Additional Details",
      collapseItems: [
        { key: 1, name: "expenses", label: "Estimated Expenses" },
        { key: 2, name: "funding_source", label: "Funding Source" },
        {
          key: 3,
          name: "local_travel_transportation",
          label: "Local Travel Transportation",
        },
        { key: 4, name: "entitlement", label: "Entitlement" },
      ],
    },
  ],
};
